<template>
  <div>
    <div style="float: right">
      <datetime-range
        id="custom-datetime-range"
        :allow-clear="false"
        :default-value="datetimeRange"
        @ok="
          v => {
            datetimeRange = v
          }
        "
      ></datetime-range>
    </div>
    <div style="clear: both"></div>
    <div
      class="module-container"
      style="height: 370px; margin: 16px 1px 0 1px"
    >
      <log-chart-card :get-func="getTrendFunc" :datetime-range="datetimeRange"></log-chart-card>
    </div>

    <div class="module-container" style="min-height: 400px; margin: 16px 1px 0 1px">
      <div class="module-header" style="margin-bottom: 14px">
        详细日志表
      </div>
      <log-table :datetime-range="datetimeRange" :columns="columns" :get-func="getTableFunc"></log-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getWindowsEventLogList, getWindowsEventLogTrend } from '@/api/log'
import DatetimeRange from '@/components/DatetimeRange'
import LogChartCard from './modules/LogChartCard.vue'
import LogTable from './modules/LogTable.vue'

export default {
  name: 'WindowsLog',
  components: {
    LogChartCard,
    DatetimeRange,
    LogTable
  },
  data () {
    return {
      datetimeRange: [moment().subtract(1, 'hour'), moment()],
      getTrendFunc: getWindowsEventLogTrend,
      getTableFunc: getWindowsEventLogList,
      columns: [
        {
          dataIndex: 'timestamp',
          title: '采集时间',
          width: 200,
          scopedSlots: {
            customRender: 'timestamp'
          }
        },
        {
          dataIndex: 'time_local',
          title: '本地时间',
          width: 200,
          scopedSlots: {
            customRender: 'timeLocal'
          }
        },
        {
          dataIndex: 'ip_address',
          title: 'IP 地址',
          width: 160,
          key: 'ip_address',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'ipAddress'
          }
        },
        {
          dataIndex: 'hostname',
          title: '主机名称',
          width: 160,
          key: 'hostname',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'hostname'
          }
        },
        {
          dataIndex: 'severity',
          title: '严重性',
          width: 90,
          key: 'severity',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'severity'
          }
        },
        {
          dataIndex: 'info',
          title: '详情',
          width: 360,
          key: 'info',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'info'
          }
        }
      ]
    }
  }
}
</script>

<style lang="less">
.module-container {
  position: relative;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
}
</style>
